import './App.css';
import './index.css';
import bgImage from './atltechevents-bg.png';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home.js';
import EmbeddedHome from './pages/EmbeddedHome';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ConfigPage from './pages/ConfigPage';
import Subscribe from './pages/Subscribe';
import PrivateEvents from './pages/PrivateEvents';
import Community from './pages/Community.js';
import HomeOld from './pages/HomeOld.js';
import NotFound from './pages/NotFound.js';
import LandscapeWarning from './components/LandscapeWarning';
import config from './config';
import { useEffect, useState } from 'react';
import { ThemeProvider, useTheme } from './context/ThemeContext';

function MobileHeader({ showMobileMenu, setShowMobileMenu }) {
  const { theme, themeName, toggleTheme } = useTheme();
  return (
    <div className={`block md:hidden flex items-center justify-between shadow-sm h-10 ${theme.background} ${theme.text} pb-2 pt-2 pl-2 pr-2`}>
      <div className="flex items-center text-center">
        <div className="flex items-center"></div>
        <Link to="/" className="flex items-center">
          <img src="favicon-32x32.png" alt="ATLTech.events" className="h-8 w-8 object-contain" />
          <span className="flex text-center w-full ml-2 font-bold text-lg">ATLTech.events</span>
        </Link>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={toggleTheme}
          className={`rounded-lg h-8 w-8 flex items-center justify-center ${theme.viewButtonInactive}`}
          aria-label={themeName === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={themeName === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          <i className={`fas fa-${themeName === 'dark' ? 'sun' : 'moon'} text-sm`} aria-hidden="true"></i>
        </button>
        <button
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          className={`rounded-lg h-8 w-8 flex items-center justify-center ${theme.viewButtonInactive}`}
          aria-label="Toggle navigation menu"
          aria-expanded={showMobileMenu}
        >
          <i className={`fas fa-${showMobileMenu ? 'times' : 'bars'} text-xl`}></i>
        </button>
      </div>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const isEmbedded = location.pathname === '/embed';
  const isHomePage = location.pathname === '/';
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const { theme, themeName, toggleTheme } = useTheme();
  
  useEffect(() => {
    // Check for app updates
    const currentVersion = localStorage.getItem('app_version');
    const currentBuildTime = localStorage.getItem('app_build_time');
    
    if (currentVersion !== config.appVersion) {
      // Clear cache and reload
      localStorage.clear();
      localStorage.setItem('app_version', config.appVersion);
      window.location.reload(true);
    }
  }, []);

  // If we're embedded and not on the /embed route, render the embedded version
  if (isEmbedded && !location.pathname.startsWith('/embed')) {
    return <EmbeddedHome />;
  }

  return (
    
    <div className={`App min-h-screen flex flex-col ${
      !isEmbedded && isHomePage ? "xl:bg-[url('atltechevents.png')] bg-[url('atltechevents-bg.png')] bg-fixed xl:bg-cover bg-center bg-no-repeat" : ""
    } h-screen ${theme.background} ${theme.text}`}>

        <link 
            rel="stylesheet" 
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" 
            integrity="sha512-9usAa10IRO0HhonpyAIVpjrylPvoDwiPUiKdWk5t3PyolY1cOd4DSE0Ga+ri4AuTroPR5aQvXU9xC6qOPnzFeg==" 
            crossOrigin="anonymous" 
            referrerPolicy="no-referrer" 
          />


      {!isEmbedded && (
        <>
          <a 
            href="#main-content" 
            className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-white focus:text-black focus:outline-none"
          >
            Skip to main content
          </a>

          <LandscapeWarning />

        <MobileHeader showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
        {showMobileMenu && (
          <div className={`block md:hidden ${theme.background} ${theme.text} shadow-lg`}>
            <nav className="flex flex-col p-4" role="navigation" aria-label="Mobile navigation">
              <Link to="/" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Home</Link>
              <Link to="/about" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>About</Link>
              <Link to="/community" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Community</Link>
              <Link to="/subscribe" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Subscribe</Link>
              <Link to="/privacy" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Privacy</Link>
              <Link to="/terms" className={`py-2 ${theme.navLink}`} onClick={() => setShowMobileMenu(false)}>Terms</Link>
              <hr className="my-2" />
              <span className="">Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">Mirability<sup>SM</sup></a></span>
               <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com"> <img src="logo-black-transparent-300.png" alt="Mirability" className="max-h-10 object-contain mx-auto" /></a>
              <div className="text-xs md:text-sm border-t border-gray-200 pt-2 mt-2">
            <p>ATLTech.events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
            <p>Copyright 2026 Mirability, LLC. All Rights Reserved.</p>
            </div>
            </nav>
          </div>
        )}

        </>
      )}

      {!isEmbedded && !isHomePage && (
        <div id="top-nav-container" className={`hidden md:block ${theme.background} border-b ${theme.border}`}>
          <div className="px-4 py-2">
            <div className="grid grid-cols-3 items-center">

              {/* Left: Logo + BETA badge */}
              <div className="flex flex-col items-start">
                <Link to="/" className="flex items-center">
                  <img src="favicon-32x32.png" alt="ATLTech.events" className="h-8 w-8 object-contain" />
                  <span className={`ml-2 font-bold text-lg ${theme.text}`}>ATLTech.events</span>
                </Link>
                <div className="mt-1 text-sm font-bold bg-yellow-600 text-white rounded-full px-2 py-0.5">
                  BETA VERSION
                </div>
              </div>

              {/* Center: empty */}
              <div />

              {/* Right: Nav links + theme toggle + Mirability */}
              <div className="flex flex-col items-end gap-1">
                <div className="flex items-center gap-4 text-sm">
                  <Link to="/" className={theme.navLink}>Home</Link>
                  <Link to="/about" className={theme.navLink}>About</Link>
                  <Link to="/community" className={theme.navLink}>Community</Link>
                  <Link to="/subscribe" className={theme.navLink}>Subscribe</Link>
                  <button
                    onClick={toggleTheme}
                    className={`p-1.5 rounded-lg ${theme.viewButtonInactive}`}
                    aria-label={themeName === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                    title={themeName === 'dark' ? 'Light mode' : 'Dark mode'}
                  >
                    <i className={`fas fa-${themeName === 'dark' ? 'sun' : 'moon'}`} aria-hidden="true"></i>
                  </button>
                </div>
                <div className="flex flex-col items-end">
                  <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com">
                    <img src="logo-black-transparent-300.png" alt="Mirability" className="max-h-10 object-contain" />
                  </a>
                  <span className={`text-xs ${theme.secondaryText}`}>Brought to you by <a target="_blank" rel="noopener noreferrer" href="https://www.mirability.com" className={theme.navLink}>Mirability<sup>SM</sup></a></span>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

<div id="scroll-here"></div>

      <main
        id="main-content"
        className="flex-grow"
        style={!isEmbedded && !isHomePage ? { backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundRepeat: 'no-repeat' } : undefined}
        role="main"
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/embed" element={<EmbeddedHome />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/private-events" element={<PrivateEvents />} />
          <Route path="/community" element={<Community />} />
          <Route path="/old" element={<HomeOld />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>


      {!isEmbedded && !isHomePage && (
        <footer className={`${theme.headerBg} ${theme.text} p-2 md:p-4 text-center bottom-0 left-0 right-0 z-10`} role="contentinfo">
        <div className="container mx-auto">

          <nav className="mb-2 md:mb-4" role="navigation" aria-label="Footer navigation">
            <div className="flex justify-center space-x-4 text-sm md:text-base">
              <Link to="/privacy" className={theme.navLink}>Privacy</Link>
              <Link to="/terms" className={theme.navLink}>Terms</Link>
            </div>
          </nav>
          <div className="text-xs md:text-sm">
          <p>ATLTech.events<sup>SM</sup> (atltech.events) and Event Horizon Media<sup>SM</sup> are the Service Marks of Mirability, LLC<sup>SM</sup>.</p>
          <p>Copyright 2026 Mirability, LLC. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
